import { render } from "./PaymentCheckout.vue?vue&type=template&id=0fb89c88&scoped=true"
import script from "./PaymentCheckout.vue?vue&type=script&lang=js"
export * from "./PaymentCheckout.vue?vue&type=script&lang=js"

import "./PaymentCheckout.vue?vue&type=style&index=0&id=0fb89c88&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hobbes\\Desktop\\abounddata-vue-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fb89c88"]])

export default __exports__